module.exports = __webpack_public_path__ + "static/media/ocorrence.491f963e.svg";